module.exports = __webpack_public_path__ + "img/boost-up-icon.0d23a2b0.svg";